import classNames from 'classnames';

type Props = React.PropsWithChildren<{ className?: string, isCompact?: boolean }>;

const Row: React.FC<Props> = ({ className, children, isCompact }) => (
  <div className={classNames(className, 'flex flex-row gap-4', isCompact ? "mt-2" : "pb-4")}>{children}</div>
);

export default Row;
